import { render } from "./RecycleStatusDialog.vue?vue&type=template&id=1f72f1ad&scoped=true"
import script from "./RecycleStatusDialog.vue?vue&type=script&lang=js"
export * from "./RecycleStatusDialog.vue?vue&type=script&lang=js"

import "./RecycleStatusDialog.vue?vue&type=style&index=0&id=1f72f1ad&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f72f1ad"]])

export default __exports__